import { RegionShared } from "@1games-ru/region-shared";
import { useLayoutEffect, useState } from "react";
import rpc from "@1games-ru/rage-rpc";

export default function useShowLoadingScreen() {
  const [isShow, setIsShow] = useState(false);

  useLayoutEffect(() => {
    rpc.register(RegionShared.Cef.Events.Loading.SetShow, ({ state }: { state: boolean }): void => {
      setIsShow(state);
    });

    return () => {
      rpc.unregister(RegionShared.Cef.Events.Loading.SetShow);
    };
  }, []);

  return {
    isShow,
  };
}
